<template>
  <div class="payment-form">
    <!-- <form action="https://sis.redsys.es/sis/realizarPago" method="post" ref="redsysForm"> -->
    <form action="https://sis-t.redsys.es:25443/sis/realizarPago" method="post" ref="redsysForm">
      <input type="hidden" name="Ds_SignatureVersion" :value="$route.params.version|base64" />
      <input type="hidden" name="Ds_MerchantParameters" :value="$route.params.merchant|base64" />
      <input type="hidden" name="Ds_Signature" :value="$route.params.signature|base64" />
      <h1 v-if="error">{{error}}</h1>
      <h1 v-else>Redirigiendo ...</h1>
    </form>
  </div>
</template>
<script>
export default {
  name: "PaymentFormData",
  data() {
    return {
      error: null,
    };
  },
  mounted() {
    const { merchant, signature, version } = this.$route.params;
    if (merchant && signature && version) {
      this.$store.commit("isLoading", true);
      this.$refs.redsysForm.submit();
    } else {
      this.error = "Los parametros del pago son incorrectos";
    }
  },
  filters: {
    base64(value) {
      if (!value) return "";
      value = value.toString();
      return atob(value);
    },
  },
};
</script>
<style lang="scss">
.payment-form {
  overflow: hidden;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  form {
    background-color: white;
    border-radius: 0.83rem;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.32);
    padding: 2.7rem 2rem;
    display: flex;
    flex-direction: column;

    h1 {
      font-size: 1.42rem;
      text-transform: uppercase;
      margin: 0;
    }
  }
}
</style>
